import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {
  estimatedTime = '30 minutes';
  constructor(public router: Router) {
  }

  ngOnInit(): void {
    setTimeout(reload => {
      window.location.reload()
    }, 10000)
  }
}